/**
 * Return the basket items/answers.
 */

import type { RootState } from '/business/shared/state/store';
import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';
import type { RefrigerantTypeOption } from '/business/shared/state/reducers/emissionTypes';

export default (state: RootState): RefrigerantTypeOption[] => state.emissionTypes?.data?.refrigerants || EMPTY_ARRAY;
